import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 56px;
  min-height: 100%;
`
export const ContainerList = styled.div`
  width: 100%;
  padding: 0 24px;
  .listItemBase__container__containerMain {
    padding: 16px 0px;
  }
  .listItemBase--inset .divider,
  .listItemBase--contained .divider {
    width: 100%;
  }
  .listItemBase--inset,
  .listItemBase--contained {
    width: 100%;
  }
`
